var exports = {
  "QS": "VoiceE2EEIndicator.module__indicatorEncrypted___OGo5VH" + " " + "VoiceE2EEIndicator.module__indicatorBase___OGo5VH",
  "pP": "VoiceE2EEIndicator.module__indicatorBroken___OGo5VH" + " " + "VoiceE2EEIndicator.module__indicatorBase___OGo5VH",
  "Gm": "VoiceE2EEIndicator.module__indicatorP2p___OGo5VH" + " " + "VoiceE2EEIndicator.module__indicatorEncrypted___OGo5VH" + " " + "VoiceE2EEIndicator.module__indicatorBase___OGo5VH",
  "RQ": "VoiceE2EEIndicator.module__indicatorP2pBroken___OGo5VH" + " " + "VoiceE2EEIndicator.module__indicatorBroken___OGo5VH" + " " + "VoiceE2EEIndicator.module__indicatorBase___OGo5VH",
};

module.exports = exports;
